module.exports = __webpack_public_path__ + "img/service_icon5-pressed.3727f68b.png";